// @ts-nocheck
/**
 * Birch Wishlist — public shared-list view. Read-only.
 * Rendered from the App Proxy endpoint /apps/wishlist/public/:slug into
 * <div data-wishlist-shared-root data-slug="...">. No login required — the
 * unguessable slug in the URL is the only thing needed to view the list.
 */
const PRODUCT_CARD_SECTION_ID = 'section-rendering-product-card';

// Mirror the wishlist grid metrics (see wishlist-manager.js) so shared cards
// match the owner's wishlist layout.
const GRID_STYLE =
  '--resource-list-column-gap-desktop: 16px;' +
  '--resource-list-row-gap-desktop: 16px;' +
  '--resource-list-columns: repeat(auto-fill, minmax(200px, 1fr));' +
  '--resource-list-columns-mobile: repeat(2, 1fr);' +
  '--column-count-mobile: 2;';

/**
 * @param {string} handle
 * @returns {Promise<string | null>}
 */
async function fetchProductCard(handle) {
  try {
    const resp = await fetch(`/products/${encodeURIComponent(handle)}?section_id=${PRODUCT_CARD_SECTION_ID}`);
    if (!resp.ok) return null;
    const html = await resp.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const cardRoot = doc.querySelector('[data-wishlist-product-card-root]');
    return cardRoot ? cardRoot.innerHTML.trim() : null;
  } catch {
    return null;
  }
}

/**
 * @param {HTMLElement} root
 */
async function init(root) {
  const slug = root.dataset.slug || new URLSearchParams(location.search).get('slug') || '';
  const heading = root.querySelector('[data-shared-heading]');
  const grid = /** @type {HTMLElement | null} */ (root.querySelector('[data-shared-grid]'));
  const status = root.querySelector('[data-shared-status]');

  const showStatus = (msg) => {
    if (!status) return;
    status.textContent = msg;
    status.classList.remove('hidden');
  };

  if (!slug) {
    showStatus('This wishlist link is invalid.');
    return;
  }

  let data;
  try {
    const resp = await fetch(`/apps/wishlist/public/${encodeURIComponent(slug)}`, {
      headers: { Accept: 'application/json' },
    });
    if (resp.status === 404) {
      showStatus('This wishlist isn’t available, or it has stopped being shared.');
      return;
    }
    if (!resp.ok) throw new Error('http_' + resp.status);
    data = await resp.json();
  } catch {
    showStatus('Something went wrong loading this wishlist. Please try again.');
    return;
  }

  if (heading && data?.name) heading.textContent = data.name;

  const items = Array.isArray(data?.items) ? data.items : [];
  if (items.length === 0) {
    showStatus('This wishlist is empty.');
    return;
  }

  const cards = await Promise.all(items.map((it) => fetchProductCard(it.handle)));
  const gridItems = cards
    .filter(Boolean)
    .map((html) => `<div class="resource-list__item">${html}</div>`)
    .join('');

  if (!gridItems) {
    showStatus('These items are no longer available.');
    return;
  }

  if (grid) {
    grid.innerHTML = `<div class="resource-list resource-list--grid" style="${GRID_STYLE}">${gridItems}</div>`;
  }
}

document.querySelectorAll('[data-wishlist-shared-root]').forEach((root) => {
  const el = /** @type {HTMLElement} */ (root);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(el));
  } else {
    init(el);
  }
});
